import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import Iconify from '../iconify';
import { GetCompaniesList, GetPositionsList, GetUsersList, PostFootfall, PostVacancy } from '../services/httpServices';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';


const CreateJob = (props) => {
  const navigate = useNavigate();

  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [selectedJobShift, setSelectedJobShift] = useState({});
  const [selectedVacancyType, setSelectedVacancyType] = useState({});
  const [selectedPosition, setSelectedPosition] = useState({});
  const [selectedEmploymentType, setSelectedEmploymentType] = useState({});
  const [positionsList, setPositionsList] = useState([]);
  const [companiesList, setCompaniesList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState({});
  const vacancyNameRef = useRef('');
  const employmentTypeRef = useRef('');
  const jobShiftRef = useRef('');
  const salaryRangeRef = useRef('');
  const vacancyTypeRef = useRef('');
  const numberOfVacancyRef = useRef('');
  const positionRef = useRef('');
  const countryOfOriginRef = useRef('');
  const remarksRef = useRef('');
  const descriptionRef = useRef('');
  const joiningDateRef = useRef('');

  const [isActive, setIsActive] = useState(true);
  const fetch = async (event) => {
    const positions = await GetPositionsList();
    positions.push({ name: 'Define New' });
    const companies = await GetCompaniesList();
    setCompaniesList(companies);
    setPositionsList(positions);
    setLoading(false);
  };
  useEffect(() => {
    fetch();
  }, []);
  // #endregion Refs

  //   const handleClose = () => {
  //     setOpen(false);
  //   };
  const handleChangeClientType = (event) => {
    setClientType(event.target.value);
  };
  const SaveVacancy = async (event) => {
    // setPosting(true);
    event.preventDefault();
    console.log('saveHit');
    // const payload = {
    //   vacancyName: vacancyNameRef.current.value,
    //   vacancyType: selectedVacancyType?.value,
    //   noOfVac: numberOfVacancyRef.current.value,
    //   location: countryOfOriginRef.current.value,
    //   salaryRange: salaryRangeRef.current.value,
    //   shift: selectedJobShift?.value,
    //   description: descriptionRef.current.value,
    //   employmentType: selectedEmploymentType.value,
    //   remarks: remarksRef.current.value,
    //   startDate: joiningDateRef?.current.value,
    //   positionId: selectedPosition?.id,
    //   positionName: selectedPosition?.name,
    //   mstCompanyName: selectedCompany?.companyName,
    //   mstCompanyId: selectedCompany?.id,
    // };

    // //  console.log(payload);
    // let response = await PostVacancy(payload);
    // // console.log('PostResponse:', response);

    // if (response.status == 200) {
    //   setMessage(response.data);
    //   setSaved(true);
    //   setOpen(true);
    //   setTimeout(() => {
    //     navigate(-1);
    //   }, 2000);
    // } else {
    //   setMessage(response.data);
    //   setSaved(false);
    //   setOpen(true);
    //   // setPosting(false);
    // }
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleSelectPosition = (position) => {
    if (position.name == 'Define New') {
      navigate('/app/CreatePosition');
    } else {
      setSelectedPosition(position);
    }
  };
  const handleChangeActive = (event) => {
    setIsActive(event.target.value);
  };
  const jobShift = ['Morning', 'Evening', 'Night'];
  const vacancyType = ['New Vacancy', 'Replacement Vacancy'];
  const employmentType = ['Regular', 'Contractual'];
  const positions = [{ value: 'Doctor' }, { value: 'Software Engineer' }];
  return (
    <>
      <Helmet>
        <title> Add Job | Immigration System </title>
      </Helmet>
      <Container>
        <form onSubmit={SaveVacancy}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Job
            </Typography>
            {/* <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}> */}

            <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
              <Button
                onClick={() => {
                  navigate(-1);
                }}
                variant="contained"
              >
                Back
              </Button>
              <Button type="submit" variant="contained">
                Create
              </Button>
            </Stack>
          </Stack>
          {loading ? (
            <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
              <CircularProgress size={60} thickness={3} value={100} />
            </Grid>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box component={Paper} p={4}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Vacancy Name"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={vacancyNameRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <Autocomplete
                        id="role"
                        size="small"
                        options={vacancyType}
                        getOptionLabel={(shift) => shift}
                        renderInput={(params) => (
                          <TextField required {...params} label="Vacancy Type" variant="outlined" />
                        )}
                        onChange={(event, vacancyType) => setSelectedVacancyType(vacancyType)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <Autocomplete
                        id="position"
                        size="small"
                        options={positionsList}
                        getOptionLabel={(position) => position.name}
                        renderInput={(params) => <TextField required {...params} label="Position" variant="outlined" />}
                        onChange={(event, position) => handleSelectPosition(position)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Number of Open Positions"
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={numberOfVacancyRef}
                        type="number"
                        InputProps={{
                          inputProps: {
                            min: 1,
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={6}>
                      <Autocomplete
                        id="employers"
                        size="small"
                        options={companiesList}
                        getOptionLabel={(company) => company.companyName}
                        renderInput={(params) => <TextField required {...params} label="Employer" variant="outlined" />}
                        onChange={(event, company) => setSelectedCompany(company)}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4} md={3}>
                      <Autocomplete
                        id="EmploymentType"
                        size="small"
                        options={employmentType}
                        getOptionLabel={(employmentType) => employmentType}
                        renderInput={(params) => (
                          <TextField required {...params} label="Employment Type" variant="outlined" />
                        )}
                        onChange={(event, employmentType) => setSelectedEmploymentType(employmentType)}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Salary Range"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={salaryRangeRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Joining Date"
                        required
                        type="date"
                        variant="outlined"
                        fullWidth
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        inputRef={joiningDateRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Origin"
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={countryOfOriginRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={6}>
                      <TextField label="Remarks" variant="outlined" fullWidth size="small" inputRef={remarksRef} />
                    </Grid>
                    <Grid item xs={12} sm={4} md={12}>
                      <TextField
                        label="Description"
                        variant="outlined"
                        fullWidth
                        size="small"
                        multiline
                        rows={2}
                        inputRef={descriptionRef}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          )}
        </form>
        {saved ? (
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
              {message}
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            key={vertical + horizontal}
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
              {message}
            </Alert>
          </Snackbar>
        )}
      </Container>
    </>
  );
};

export default CreateJob;
